import getElementAfterDraggingElement from './getElementAfterDraggingElement';
import getLastOrganization from '../../../../../getLastOrganization';

export default (params) => {
  const { dragType, droppable, e, clientY } = params;

  let className;
  let afterOrg;
  let afterRole;
  let parentNode;
  if (dragType === 'ORGANIZATION') {
    className = 'organization';
    afterOrg = getElementAfterDraggingElement(
      droppable,
      Math.max(clientY || e.clientY, 120),
      className,
    );
    parentNode = droppable;
  } else if (dragType === 'ROLE' || dragType === 'ROLE_ARRAY_ITEM') {
    className = dragType === 'ROLE' ? 'role-details' : 'array-items';
    afterRole = getElementAfterDraggingElement(
      droppable,
      clientY || e.clientY,
      className,
    );
    if (afterRole) {
      parentNode = afterRole.parentElement;
      const { top: parentNodeTop } = parentNode.getBoundingClientRect();
      if (parentNodeTop > (clientY || e.clientY)) {
        const {
          parentElement: { previousSibling: previousOrg },
        } = parentNode;
        if (previousOrg) {
          const { children: prevOrgChildren } = previousOrg;
          const prevRoleParent = prevOrgChildren[1];
          parentNode = prevRoleParent;
        }
      }
    } else {
      parentNode = getLastOrganization();
    }
  } else if (dragType === 'ARRAY_ITEM') {
    afterRole = getElementAfterDraggingElement(
      droppable,
      clientY || e.clientY,
      'array-items',
    );
    parentNode = droppable;
  }
  return { className, afterOrg, parentNode, afterRole };
};
